import {
  ApplicationInsights,
  DistributedTracingModes,
  ITelemetryItem,
} from "@microsoft/applicationinsights-web"
import { ReactPlugin } from "@microsoft/applicationinsights-react-js"

export const reactPlugin = new ReactPlugin()

let localOnlyLogging = true // Default to local logging

// Create a simple AppInsights instance that will be configured to either log locally or remotely
export const appInsights = new ApplicationInsights({
  config: {
    connectionString: "InstrumentationKey=XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    distributedTracingMode: DistributedTracingModes.W3C,
  },
})

appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
  if (isLocalOnlyLogging()) {
    // Log to console instead of sending to AppInsights
    console.group("App Insights Logs (Local Only)")
    console.log(env)
    console.groupEnd()
    // Return false to prevent sending to server
    return false
  } else {
    // Add standard tags for remote logging
    env.tags = env.tags || []
    env.tags["ai.cloud.role"] = "affiliate-web"
    env.data = env.data || {}
    env.data.UserSessionId =
      appInsights.context.sessionManager.automaticSession.id
    // Return true to allow sending to server
    return true
  }
})

// Add dependency listener
appInsights.addDependencyListener((details) => {
  const guid = crypto.randomUUID()
  details.traceId = guid
})

// Load AppInsights with initial configuration (will use local logging)
appInsights.loadAppInsights()

// Function to update AppInsights with a real connection string
export const initializeAppInsights = (connectionString: string) => {
  // Check if we have a valid connection string
  if (!connectionString || !connectionString.includes("InstrumentationKey")) {
    // Keep using local logging
    setLocalOnlyLogging(true)
    return
  }
  // Update the connection string
  appInsights.config.connectionString = connectionString

  // Switch to remote logging
  setLocalOnlyLogging(false)

  // Track initial page view now that we're configured for remote logging
  appInsights.trackPageView()
}

// Provide a setter to control localOnlyLogging
export const setLocalOnlyLogging = (value: boolean) => {
  localOnlyLogging = value
}

// Optionally, provide a getter if needed elsewhere
export const isLocalOnlyLogging = () => localOnlyLogging
